import React from "react";
import styled from "styled-components";
import vagasBlue from "../../assets/vagasBlue.png";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17.5px;
  background-color: #fffef9;
  border-bottom: 1px solid #ddd;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const TitleText = styled.div`
  font-size: 20px;
  color: #ff9f1f;
  font-weight: bold;
  margin-left: 0px;
`;

const TextAndIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const SectionLabel = styled.div`
  font-size: 18px;
  color: #002e3b;
  font-weight: 600;
  margin-left: 45px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Wrapper = styled.div`
  @media (max-width: 768px) {
    padding-top: 50px;
  }
`;

const SolicitarHeader = () => {
  return (
    <Wrapper>
      <Container>
        <TextAndIcon>
          <SectionLabel>VAGAS</SectionLabel>
          <img
            src={vagasBlue}
            alt="Vagas"
            style={{
              marginLeft: "0px",
              width: "40px",
              height: "40px",
              marginTop: "5px",
            }}
          />
          <TitleText>
            <i>Solicitar Vagas de Estágio</i>
          </TitleText>
        </TextAndIcon>
      </Container>
    </Wrapper>
  );
};

export default SolicitarHeader;


